interface FiscalTab {
  label: string;
  count?: number;
}

interface Props {
  tabs: FiscalTab[];
  activeIndex: number;
  onChange: (index: number) => void;
  ariaLabel: string;
}

export default function FiscalTabs({ tabs, activeIndex, onChange, ariaLabel }: Props) {
  return (
    <div role="tablist" aria-label={ariaLabel} className="flex gap-2 overflow-x-auto border-b border-stroke pb-3 dark:border-strokedark">
      {tabs.map((tab, index) => (
        <button
          key={tab.label}
          type="button"
          role="tab"
          aria-selected={activeIndex === index}
          tabIndex={activeIndex === index ? 0 : -1}
          onClick={() => onChange(index)}
          onKeyDown={(event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            const offset = event.key === 'ArrowRight' ? 1 : -1;
            onChange((index + offset + tabs.length) % tabs.length);
          }}
          className={`whitespace-nowrap rounded-xl px-4 py-2.5 text-sm font-medium transition focus:outline-none focus:ring-2 focus:ring-primary/20 ${
            activeIndex === index
              ? 'bg-primary text-white shadow-sm'
              : 'bg-gray-2 text-black hover:bg-primary/10 hover:text-primary dark:bg-meta-4 dark:text-white'
          }`}
        >
          {tab.label}{typeof tab.count === 'number' && <span className="ml-2 rounded-full bg-white/20 px-2 py-0.5 text-xs">{tab.count}</span>}
        </button>
      ))}
    </div>
  );
}
